import { useEffect, useRef } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import { responsiveIFrameContainer } from "../../../../../design-system/components/Video/Video.jsx";

const VideoJS = (props) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const propsRef = useRef(props);
  propsRef.current = props;

  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = document.createElement("video-js");
      videoElement.className = "vjs-fill"; // Makes video.js fill the container
      videoRef.current.appendChild(videoElement);

      const player = (playerRef.current = videojs(
        videoElement,
        {
          ...propsRef.current.options,
          responsive: true,
          fluid: true,
          aspectRatio: "16:9",
          fill: true,
        },
        () => {
          propsRef.current.onReady?.(player);
        },
      ));
    } else {
      const player = playerRef.current;
      player.autoplay(propsRef.current.options.autoplay);
      player.src(propsRef.current.options.sources);
    }
  }, []);

  useEffect(() => {
    const player = playerRef.current;
    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  const containerStyles = {
    ...responsiveIFrameContainer(9 / 16),
    // Ensure proper video display
    "& .videoJs": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "contain", // This ensures the video maintains its aspect ratio
    },
  };

  return (
    <div style={containerStyles}>
      <div
        ref={videoRef}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      />
    </div>
  );
};

export default VideoJS;
